<template>
  <div class="-social">
    <div class="-thumbnail-wrapper">
      <div v-if="!!src" class="-thumbnail" @click="previewAsset">
        <a href="#">
          <img :src="mixinSrc(src)" />
        </a>
        <slot name="checkmark"></slot>
      </div>
      <div v-else class="-post" @click="previewAsset">
        <div class="-inner">
          <!--<div class="-post-text" dir="auto">-->
          <!--{{asset.metadata.caption}}-->
          <!--</div>-->
          <span class="-social-icon -facebook"></span>
        </div>
      </div>
      <footer class="-social">
        <div class="-asset-details">
          <div class="-date" :title="publicationDateFull">
            {{ publicationDate }}
          </div>
          <div class="-activity">
            <template v-if="reactionsCount">
              <span class="wticon wticon-facebook-like"></span>
              <span>{{ reactionsCount }}</span>
            </template>
            <template v-if="sharesCount">
              <span class="wticon wticon-facebook-share"></span>
              <span>{{ sharesCount }}</span>
            </template>
          </div>
        </div>
        <div class="-user-details">
          <img
            class="wt-asset-social-profile-image"
            :src="asset.metadata.socialUserProfileImageUrl"
          />
          <span class="-social-name">{{ asset.metadata.socialUserName }}</span>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import AssetMixins from 'components/assets/mixins/AssetMixins.vue';
import Vue from 'vue';

export default Vue.extend({
  mixins: [AssetMixins],

  computed: {
    type() {
      const type = this.asset.metadata.facebookAssetMetadata.facebookPostType;
      return type || 'text';
    },

    isVideo() {
      return this.type === 'video';
    },

    isImage() {
      return this.type === 'photo';
    },

    src() {
      if (this.isVideo) {
        return this.asset.metadata.posterUrl;
      }
      if (this.isImage) {
        return this.asset.metadata.providerLowResAssetUrl;
      }

      return null;
    },
    reactionsCount() {
      const count = _.objectPath(
        this.meta,
        'facebookAssetMetadata.socialReactionsCount'
      );
      if (!count) {
        return 0;
      }
      return count.toFriendlyNumber(1);
    },
    commentsCount() {
      const count = _.objectPath(
        this.meta,
        'facebookAssetMetadata.socialCommentsCount'
      );
      if (!count) {
        return 0;
      }
      return count.toFriendlyNumber(1);
    },
    sharesCount() {
      const count = _.objectPath(
        this.meta,
        'facebookAssetMetadata.socialSharesCount'
      );
      if (!count) {
        return 0;
      }
      return count.toFriendlyNumber(1);
    },
  },
});
</script>
